import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CheckIcon from '@mui/icons-material/Check';

const useStyles = makeStyles(() => ({
    root: {
        marginLeft: '24px',
        marginRight: '24px'
      },
    head: {
        color: '#0009b7',
        fontWeight: 'regular',
        padding:'6px 0'
      }


  }));

  

  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }

  const rows = [
    createData('A', 'ระบบหรือนโยบายภายในบริษัท', '', 10, '-'),
    createData('B', 'ความซื่อสัตย์ทางธุรกิจ', 'Business Integrity', 20, '-'),
    createData('C', 'สังคม', 'Society', 20, '-'),
    createData('D', 'อาชีวอนามัย และ ความปลอดภัย', 'Occupational Health and Safty', 25, '-'),
    createData('E', 'สิ่งแวดล้อม', 'Environment', 25, '-'),
  ];

  const editIcon = (data) => (
    <IconButton>
      <EditIcon fontSize="small"/>
    </IconButton>
  );

  const addIconTab = (data) => (
    <Grid container  columns={16} direction="row" justifyContent="left">
    <IconButton onClick={() => editIconTab(data)}>
      <CheckIcon  fontSize="small"/>
    </IconButton>
    <IconButton onClick={() => editIconTab(data)}>
      <DeleteIcon fontSize="small"/>
    </IconButton>
    </Grid>
  );

  const editIconTab = (data) => (
    <Grid container  columns={16} direction="row" justifyContent="left">
    <IconButton onClick={() => editIconTab(data)}>
      <EditIcon  fontSize="small"/>
    </IconButton>
    <IconButton onClick={() => editIconTab(data)}>
      <DeleteIcon fontSize="small"/>
    </IconButton>
    <IconButton onClick={() => editIconTab(data)}>
      <ArrowDownwardIcon fontSize="small"/>
    </IconButton>
    </Grid>
  );

function EvaluationFormScreen(){
    const classes = useStyles();
    const [Datevalue1, DatesetValue1] = React.useState(new Date());
    const [Datevalue2, DatesetValue2] = React.useState(new Date());

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }));
      
    return (
        <div style={{backgroundColor: "#f5f6f7",height:"100%"}}>
            <div className={classes.root}>
                <Grid container spacing={2} columns={16} style={{margin: "0",width:"100%",paddingTop:"15px",paddingBottom:"15px"}}>
                    <Grid xs={8}>
                        <div className={classes.head}>
                            <h1 sx>สร้างแบบประเมิน ESG</h1>
                        </div>
                    </Grid>
                    <Grid xs={8}>
                        <Stack spacing={1} direction="row" justifyContent="flex-end" alignItems="center">
                            <Button style={{backgroundColor: "#37cfd0",fontWeight:"bold"}} variant="contained">Preview แบบประเมิน</Button>
                            <Button style={{backgroundColor: "#ff8c06",fontWeight:"bold"}} variant="contained">บันทึกร่าง</Button>
                            <Button style={{backgroundColor: "#04b22b",fontWeight:"bold"}} variant="contained">ยืนยันใช้แบบประเมิน</Button>
                            <Button onClick={() => { window.location.href = '/Evaluation' }} style={{backgroundColor: "#a7a5a5",fontWeight:"bold"}} variant="contained">กลับ</Button>
                        </Stack>
                    </Grid>
                </Grid>
                <Box sx={{ bgcolor: '#ffffff',borderRadius:'10px',padding:'20px' }}>
                    <Grid container spacing={2}>
                        {/* 1st row */}
                        <Grid item xs={2} sx={{ textAlign: 'right',fontWeight:'bold',paddingTop:'24.5px !important' }}>
                            <label>Version</label><span style={{color:'red'}}>*</span>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField id="outlined-basic" size="small" style={{width:'350px'}} value="2022 - "/>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: 'right',fontWeight:'bold',paddingTop:'24.5px !important' }}>
                            <label>วันที่เริ่มใช้งาน</label><span style={{color:'red'}}>*</span>
                        </Grid>
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    mask="____/__/__"
                                    value={Datevalue1}
                                    onChange={(newValue) => DatesetValue1(newValue)}
                                    renderInput={(params) => <TextField size="small" style={{ backgroundColor: 'white' }} fullWidth  {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: 'right', fontWeight: 'bold', paddingTop: '24.5px !important' }}>
                            <label>วันที่สิ้นสุดใช้งาน</label><span style={{ color: 'red' }}>*</span>
                        </Grid>
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    mask="____/__/__"
                                    value={Datevalue1}
                                    onChange={(newValue) => DatesetValue1(newValue)}
                                    renderInput={(params) => <TextField size="small" style={{ backgroundColor: 'white' }} fullWidth  {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>


                        {/* 2nd row */}
                        <Grid item xs={2} sx={{ textAlign: 'right',fontWeight:'bold',paddingTop:'24.5px !important' }}>
                            <label>คะแนนขั้นต่ำที่ผ่านเกณฑ์</label><span style={{color:'red'}}>*</span>
                        </Grid>
                        <Grid item xs={1}>
                            <TextField id="outlined-basic" size="small" style={{width:'80px'}}/>
                        </Grid>
                        <Grid item xs={1.5} sx={{ textAlign: 'right',fontWeight:'bold',paddingTop:'24.5px !important' }}>
                            <label>น้ำหนัก Weight % รวม</label><span style={{color:'red'}}>*</span>
                        </Grid>
                        <Grid item xs={7}>
                            <TextField id="outlined-basic" size="small" style={{width:'80px'}}/>
                        </Grid>

                        {/* 3rd row */}
                        <Grid item xs={2} sx={{ textAlign: 'right',fontWeight:'bold',paddingTop:'24.5px !important' }}>
                            <label>ชื่อแบบประเมิน (ภาษาไทย)</label><span style={{color:'red'}}>*</span>
                        </Grid>
                        <Grid item xs={10}>
                            <TextField id="outlined-basic" size="small" sx={{width:'95%'}}/>
                        </Grid>

                        {/* 4th row */}
                        <Grid item xs={2} sx={{ textAlign: 'right',fontWeight:'bold',paddingTop:'24.5px !important' }}>
                            <label>ชื่อแบบประเมิน (ภาษาอังกฤษ)</label>
                        </Grid>
                        <Grid item xs={10}>
                            <TextField id="outlined-basic" size="small" sx={{width:'95%'}}/>
                        </Grid>

                        {/* 5 row */}
                        <Grid item xs={2} sx={{ textAlign: 'right',fontWeight:'bold',paddingTop:'24.5px !important' }}>
                            <label>คำอธิบายแบบประเมิน (ภาษาไทย)</label><span style={{color:'red'}}>*</span>
                        </Grid>
                        <Grid item xs={4} sx={{ textAlign: 'right',fontWeight:'bold',paddingTop:'24.5px !important' }}>
                        </Grid>
                        <Grid item xs={6} sx={{ fontWeight:'bold',paddingTop:'24.5px !important' }}>
                            <label>คำอธิบายแบบประเมิน (ภาษาอังกฤษ)</label>
                        </Grid>

                        {/* 6 row */}
                        <Grid item xs={6} sx={{ fontWeight: 'bold', paddingTop: '0 !important' }}>
                            <TextareaAutosize minRows={10} style={{ width: '100%', resize: 'none' }} />
                        </Grid>
                        <Grid item xs={6} sx={{ fontWeight: 'bold', paddingTop: '0 !important' }}>
                            <TextareaAutosize minRows={10} style={{ width: '100%', resize: 'none' }} />
                        </Grid>

                    </Grid>
                </Box>
                <br/>
                <Box sx={{ bgcolor: '#ffffff',borderRadius:'10px',padding:'20px' }}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{fontWeight: 'bold',color:'#ffffff',backgroundColor:'#00ace2'}}></TableCell>
                                    <TableCell align="center" style={{fontWeight: 'bold',color:'#ffffff',backgroundColor:'#00ace2'}}>หัวข้อหมวดคำถาม</TableCell>
                                    <TableCell align="center" style={{fontWeight: 'bold',color:'#ffffff',backgroundColor:'#00ace2'}}>หมวดคำถาม (ภาษาไทย)</TableCell>
                                    <TableCell align="center" style={{fontWeight: 'bold',color:'#ffffff',backgroundColor:'#00ace2'}}>หมวดคำถาม (ภาษาอังกฤษ)</TableCell>
                                    <TableCell align="center" style={{fontWeight: 'bold',color:'#ffffff',backgroundColor:'#00ace2'}}>น้ำหนัก Weight %</TableCell>
                                    <TableCell align="center" style={{fontWeight: 'bold',color:'#ffffff',backgroundColor:'#00ace2'}}>จำนวน (คำถาม)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>



                                {rows.map((row) => (
                                    <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                        <TableCell align="center">{editIconTab(1)}</TableCell>
                                        <TableCell style={{cursor:'pointer'}} component="th" scope="row" align="center">{row.name}</TableCell>
                                        <TableCell align="left">{row.calories}</TableCell>
                                        <TableCell align="left">{row.fat}</TableCell>
                                        <TableCell align="center">{row.carbs}</TableCell>
                                        <TableCell align="center">{row.protein}</TableCell>
                                    </TableRow>
                                ))}
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                        <TableCell align="center">{addIconTab(1)}</TableCell>
                                        <TableCell component="th" scope="row" align="center"><TextField id="standard-basic" variant="standard" /></TableCell>
                                        <TableCell align="left"><TextField id="standard-basic" variant="standard" /></TableCell>
                                        <TableCell align="left"><TextField id="standard-basic" variant="standard" /></TableCell>
                                        <TableCell align="center"><TextField id="standard-basic" variant="standard" /></TableCell>
                                        <TableCell align="center"><TextField id="standard-basic" variant="standard" /></TableCell>
                                    </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <br/>
                    <Button variant="outlined" style={{color:'#ffbb6b',borderColor:'#ffbb6b',fontWeight:'bold'}}>+ เพิ่มหมวดคำถาม</Button>
                </Box>
            </div>
            
        </div>
    );

}

export default EvaluationFormScreen;